import { FC } from "react";
import { ChatMsgDetail } from "../../store/ChatAction";
import { isAgent } from "../../utils";
import { ChatMessageBubble } from "../ChatMessageBubble";

export interface ChatTextMessageProps {
    readonly message: ChatMsgDetail;
    readonly sibling: boolean;
}

export const ChatTextMessage: FC<ChatTextMessageProps> = (props) => {
    const message = props.message;
    const date = new Date(message.timestamp);

    const time = date.getHours() + ":" + date.getMinutes();

    const agentMessage = isAgent(props.message.user.nick);

    return (
        <div className="chat-msg">
            <div className="chat-text-container">
                <ChatMessageBubble
                    owner={agentMessage ? "others" : "mine"}
                    hasTail={agentMessage && !props.sibling}>
                    <span className="message-sr-only">
                        {"at " + time + (agentMessage ? " the bot said" : " the user said")}
                    </span>
                    <span>{message.msg.text}</span>
                </ChatMessageBubble>
            </div>
        </div>
    );
};
